module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAA9UlEQVR4AWMYHKDZ1OM/e17af4bCDNIwDFwSMPm/XsH2v0JSAvkGgPAJUbP//j4hpBtwGaj5hpDZ/5syRv8v8Zv+fxBb+v/v9x//CQCEASeEDf9Xyon+35LL/n+loNr/K8JAL/Fq/1dg4gApwokRBmiq/S9J0ftf3FT2/85k2/9XxQzAXjrIb/C/i1uJsAHrWLT+r6w1/39rY+r/rX4G/y9ymvzfxKfzX5mZkzgXXAY6+Zayzv/LvHr/byjr/X+YWPH/75evhIIAMxYuixv9fzNJ5P+fhwzEYFQDbhjo/P+6nxMkQboBj+IV/v+6zgQSJM2A4QEALFVgl2h2zbUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/MZ.png
// module id = 1222
// module chunks = 0